import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class DeleteUserRequest extends Request {
    constructor(login) {
        super({
            req: RequestTypes.DELETE_USER,
            req_id: 0,
            login: login
        });
    }
}

export default DeleteUserRequest;